/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CurrentUserProfileDto
 */
export interface CurrentUserProfileDto {
    /**
     * 
     * @type {string}
     * @memberof CurrentUserProfileDto
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserProfileDto
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserProfileDto
     */
    profilePictureId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserProfileDto
     */
    $type?: CurrentUserProfileDtoTypeEnum;
}


/**
 * @export
 */
export const CurrentUserProfileDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationAccountDtoCurrentUserProfileDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Account.Dto.CurrentUserProfileDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CurrentUserProfileDtoTypeEnum = typeof CurrentUserProfileDtoTypeEnum[keyof typeof CurrentUserProfileDtoTypeEnum];


/**
 * Check if a given object implements the CurrentUserProfileDto interface.
 */
export function instanceOfCurrentUserProfileDto(value?: unknown): value is CurrentUserProfileDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CurrentUserProfileDtoTypeEnum)[0];
}

export function CurrentUserProfileDtoFromJSON(json: any): CurrentUserProfileDto {
    return CurrentUserProfileDtoFromJSONTyped(json, false);
}

export function CurrentUserProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentUserProfileDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timezone': json['timezone'],
        'language': json['language'],
        'profilePictureId': !exists(json, 'profilePictureId') ? undefined : json['profilePictureId'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CurrentUserProfileDtoToJSON(value?: CurrentUserProfileDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'timezone': value.timezone,
        'language': value.language,
        'profilePictureId': value.profilePictureId,
        '$type': value.$type,
    });
}

